import * as PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link, createSearchParams, useNavigate } from 'react-router-dom';
import json from '../../../../../package.json';
import EmptyCurrency from '../../../../components/EmptyCurrency/EmptyCurrency';
import ListItem from '../../../../components/ListItem/ListItem';
import { CurrencyItemWithSkeleton } from '../../../../components/Skeletons/ItemsWithSkeleton';
import ListItemSkeleton from '../../../../components/Skeletons/ListItemSkeleton';
import AppConfig from '../../../../config';
import { t } from '../../../../lang';
import HelperService from '../../../../services/HelperService';
import StorageService from '../../../../services/StorageService';

import './AssetsBlock.scss';

const CREDIT_CURRENCY = AppConfig?.creditCurrency ?? json.creditCurrency ?? 'Credits';
const CREDIT_CURRENCY_ICON = AppConfig?.creditCurrencyIcon ?? 'Credits';

const creditIconNode = AppConfig?.creditCurrencyIcon ? (
	<img src={AppConfig.creditCurrencyIcon} alt={AppConfig.creditCurrency} width={40} height={40} />
) : (
	CREDIT_CURRENCY
);

const { routes } = AppConfig;

const AssetsBlock = ({ assetCount = 3, showBilling = true }) => {
	const availableCurrencies = useSelector(store => store.app.availableCurrencies);
	const billingBalance = useSelector(store => store.app.billingBalance);
	const quotes = useSelector(store => store.app.quotes);

	const availableCurrenciesLoading = useSelector(store => store.app.availableCurrenciesLoading);

	const navigate = useNavigate();

	const sortedCurrencies = [...availableCurrencies].sort((a, b) => b.AmountUsd - a.AmountUsd);
	const cuttedCurrencies = sortedCurrencies.slice(0, assetCount);

	const billingRate = quotes.find(quote => quote.Symbol === 'Credits')?.Rate || 0;
	const billingBalanceUsd = billingBalance * billingRate;

	useEffect(() => {
		StorageService.UpdateCurrencies();
	}, []);

	const openAsset = currency => {
		navigate({ pathname: routes.asset, search: createSearchParams({ currencyId: currency.Id }).toString() });
	};

	const openBillingItem = () => {
		navigate({ pathname: routes.billingCurrency });
	};

	const testVerify = () => {
		navigate({ pathname: routes.verifyDevice });
	};

	return (
		<div className='AssetsBlock'>
			<div className='FormBlock'>
				{cuttedCurrencies.length > 0 ? (
					<>
						<div className='AssetsBlock__header'>
							<div className='AssetsBlock__title'>{t('Assets')}</div>
							<Link to={routes.assets}>{t('View all')}</Link>
						</div>

						<CurrencyItemWithSkeleton
							loading={availableCurrenciesLoading}
							items={cuttedCurrencies}
							onClick={openAsset}
						/>
					</>
				) : (
					<EmptyCurrency />
				)}
			</div>

			{showBilling &&
				(availableCurrenciesLoading ? (
					<div className='AssetsBlock__billing-item FormBlock'>
						<ListItemSkeleton />
					</div>
				) : (
					<ListItem
						className='AssetsBlock__billing-item FormBlock'
						icon={creditIconNode}
						iconLabel={'GAS_PUMP_RIM'}
						title={CREDIT_CURRENCY}
						description={AppConfig?.name + ' USD'}
						rightTitle={HelperService.FormatFiatWithoutCurrency(billingBalance)}
						rightDescription={'$' + HelperService.FormatFiatWithoutCurrency(billingBalanceUsd)}
						onSelect={openBillingItem}
					/>
				))}
		</div>
	);
};

AssetsBlock.propTypes = {
	assetCount: PropTypes.number,
	showBilling: PropTypes.bool,
};

export default AssetsBlock;
